import { Box } from '@givebutter/primitives/box';
import { Separator } from '@givebutter/primitives/separator';
import { CampaignTeamFundraisingSettings } from 'assets/js/pages/campaign-settings/campaign-team/CampaignTeamFundraisingSettings';
import { CampaignTeamMultiTeamFundraisingSettings } from 'assets/js/pages/campaign-settings/campaign-team/CampaignTeamMultiTeamFundraisingSettings';

const CampaignTeamSettings = () => {
    return (
        <Box className={'flex flex-col gap-8 p-8'}>
            <CampaignTeamFundraisingSettings />
            <Separator />
            <CampaignTeamMultiTeamFundraisingSettings />
        </Box>
    );
};

export { CampaignTeamSettings };
